import "../assets/css/ManejoUsuario.css";

function ManejoUsuario(props) {
  const { username, profile_picture, email, mostrame, uid } = props;
  return (
    <>
      <div className="contenidoUsurio">
        {profile_picture && (
          <img className="fotito" src={profile_picture} alt="" />
        )}

        <p className="datito">{username}</p>
        {email && <p className="datito"> {email}</p>}

        <button
          onClick={() => {
            mostrame(uid);
          }}
        >
          Ver
        </button>
      </div>
    </>
  );
}

export default ManejoUsuario;
